export const partBrandsHeaderVn = "Đối tác ShopeePay"